import { get } from "../axios/http"

export const getAppCategory = () => get('/api/Cgs/Portal/Category/List?VisualType=App')

export const getAppList = (category) => get(`/api/Cgs/Portal/Visual/List?Category=${category}&Current=1&VisualType=App`)